exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#customer-show-bank-order .modal-dialog{max-width:75%}", ""]);

// exports
